import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import 'air-datepicker/air-datepicker.css';
import { parseIsoDate, formatIsoDate } from '../utils/date-input.utils.js';

export function initSiteDatePicker(root = document) {
  const inputs = root.matches?.('[data-site-date-picker]') ? [root] : root.querySelectorAll('[data-site-date-picker]');
  inputs.forEach((input) => {
    if (input._siteDatepicker) return;
    const target = input.ownerDocument.getElementById(input.dataset.dateTarget);
    if (!target) return;
    const selectedDate = parseIsoDate(target.value);
    const syncDate = (date) => {
      target.value = date instanceof Date ? formatIsoDate(date) : '';
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
    };
    input._siteDatepicker = new AirDatepicker(input, {
      locale: { ...(localeEn.default ?? localeEn), firstDay: 1 },
      classes: 'site-datepicker',
      dateFormat: 'dd/MM/yyyy',
      isMobile: window.matchMedia('(max-width: 640px)').matches,
      autoClose: true,
      buttons: ['clear'],
      selectedDates: selectedDate ? [selectedDate] : [],
      onSelect: ({ date }) => {
        const selected = Array.isArray(date) ? date[0] : date;
        syncDate(selected);
      },
    });
    input.form?.addEventListener('reset', () => {
      window.setTimeout(() => {
        input._siteDatepicker.clear({ silent: true });
        if (selectedDate) input._siteDatepicker.selectDate(selectedDate, { silent: true });
        syncDate(selectedDate);
      }, 0);
    });
  });
}

if (typeof document !== 'undefined') {
  window.initSiteDatePicker = initSiteDatePicker;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSiteDatePicker());
  else initSiteDatePicker();
}
